<template>
  <div>
    <div v-if="isVisible" class="loader-overlay">
      <div class="loader"></div>
      <div class="text" align="center" valign="middle">
        <b><span v-html="text"></span></b>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Loader",
  props: {
    isVisible: { type: Boolean, required: true },
    text: { type: String, required: false, default: "" },
  },
};
</script>


<style>
.loader-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
}
.text {
  position: absolute;
  top: calc(50% + 60px);
  left: 50%;
  color: black;
  width: 1px;
  height: 1px;
  overflow: visible;
}

.loader {
  animation: loader-animate 1.5s linear infinite;
  clip: rect(0, 80px, 80px, 40px);
  height: 80px;
  width: 80px;
  position: absolute;
  left: calc(50% - 40px);
  top: calc(50% - 40px);
}
.loader:after {
  animation: loader-animate-after 1.5s ease-in-out infinite;
  clip: rect(0, 80px, 80px, 40px);
  content: "";
  border-radius: 50%;
  height: 80px;
  width: 80px;
  position: absolute;
}

@keyframes loader-animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(220deg);
  }
}

@keyframes loader-animate-after {
  0% {
    box-shadow: inset #470000 0 0 0 5px;
    transform: rotate(-140deg);
  }
  50% {
    box-shadow: inset #0000ff 0 0 0 5px;
  }
  100% {
    box-shadow: inset #ff0000 0 0 0 5px;
    transform: rotate(140deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue